__turbopack_context__.v({
  "errorHolder": "index-module-scss-module__yvbMBG__errorHolder",
  "header": "index-module-scss-module__yvbMBG__header",
  "title": "index-module-scss-module__yvbMBG__title",
});
